// #region imports

// --- Angular
import { FormGroup } from '@angular/forms';

// #endregion

export function CompareValidator(operation: string, firstControlName: string, secondControlName: string) {
  return (formGroup: FormGroup) => {
    const firstControl = formGroup.controls[firstControlName];
    const secondControl = formGroup.controls[secondControlName];

    if (secondControl.errors && !secondControl.errors['mustMatch']) {
      return;
    }

    switch (operation) {
      case 'eq':
        if ((firstControl.value !== secondControl.value) && secondControl.enabled) {
          secondControl.setErrors({ isEqual: true });
        } else {
          secondControl.setErrors(null);
        }
        break;
    }
  };
}
